export const audioLevelMap = new Map();
export const statsMap = new Map();
